import { colors } from '@material-ui/core';

export default {
  root:{
    "&:first-child": {
    }
  },
};